<template>
  <div id="Thelecture" class="scrollBar">
    <Header :title="$t('Login.ControllerTitle')" logoutPath="/Controller/Login" :tabShow="tab" :timerShow="true" />
    <div class="lectureInfoScroll">
      <div class="lectureInfo">
        <img class="lectureIcon" src="@/assets/img/controller/icon_lecture.png" />
        <div class="lectureName">{{ lectureName }}</div>
        <img class="lecturePicture" :src="lectureImgUrl" />
        <div class="lectureStatus">{{ $t('Controller.LectureStatus') }}</div>
        <div class="lectureUsing">{{ $t('Controller.LectureUsing') }}</div>
      </div>
      <button class="lectureStop" @click="ShowStopDialog">{{ $t('Controller.LectureStop') }}</button>
    </div>

    <DialogMsg
      :show="dialogStopLecture.isShow"
      :title="dialogStopLecture.title"
      :content="dialogStopLecture.content"
      :btnRightText="dialogStopLecture.btnRightText"
      :btnLeftText="dialogStopLecture.btnLeftText"
      :twoBtn="dialogStopLecture.twoBtn"
      @close-dialog="CloseStopDialog"
      @btn-right-click="StopLecture"
      @btn-left-click="CloseStopDialog"
    />
    <DialogMsg
      :show="dialogStoped.isShow"
      :title="dialogStoped.title"
      :content="dialogStoped.content"
      :btnRightText="dialogStoped.btnRightText"
      :btnLeftText="dialogStoped.btnLeftText"
      :twoBtn="dialogStoped.twoBtn"
      @close-dialog="CloseDialog"
      @btn-right-click="CloseDialog"
      @btn-left-click="CloseDialog"
    />
  </div>
</template>

<script>
import '@/assets/scss/controller.scss';
import '@/assets/scss/controllerResponsive.scss';
import Header from '@/components/Controller/Header.vue';
import DialogMsg from '@/components/Controller/DialogMsg.vue';

export default {
  data() {
    return {
      tab: 'lecture',
      dialogStopLecture: {
        isShow: false,
        title: '',
        content: '',
        btnRightText: '',
        btnLeftText: '',
        twoBtn: true,
      },
      dialogStoped: {
        isShow: false,
        title: '',
        content: '',
        btnRightText: '',
        btnLeftText: '',
        twoBtn: true,
      },
      count: 0,
    };
  },
  mounted() {
  },
  watch: {},
  computed: {
    lectureName() {
      return localStorage.getItem('usingLecture');
    },
    lectureImgUrl() {
      return localStorage.getItem('usingPicture');
    },
  },
  methods: {
    StopLecture() {
      let data = {
        PackageName: 'home',
      };
      let usingSecond = localStorage.getItem('usingTime');
      this.$store.dispatch('ClearTheLecture', data).then((res) => {
        if (res == 'ok') {
          this.dialogStoped = {
            isShow: false,
            title: this.$t('Controller.LectureStoped'),
            content: this.$t('Controller.LectureReturnList') + '<br>' + this.SecondToTime(usingSecond),
            btnRightText: this.$t('Controller.Confirm'),
            btnLeftText: '',
            twoBtn: false,
          };
          this.dialogStoped.isShow = true;
          this.dialogStopLecture.isShow = false;
        }
        //this.ConsoleLog(`res: ${res}, StopLecture`);
      });
    },
    ShowStopDialog() {
      this.dialogStopLecture = {
        isShow: false,
        title: this.$t('Controller.LectureStop'),
        content: this.$t('Controller.LectureStopHint'),
        btnRightText: this.$t('Controller.Confirm'),
        btnLeftText: this.$t('Controller.Cancel'),
        twoBtn: true,
      };
      this.dialogStopLecture.isShow = true;
    },
    CloseStopDialog() {
      this.dialogStopLecture.isShow = false;
    },
    CloseDialog() {
      this.$router.push({ path: '/Controller/Lecture' });
      this.dialogStoped.isShow = false;
    },
  },
  components: {
    Header,
    DialogMsg,
  },
};
</script>
